import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "clock-root" }

import { computed } from 'vue'
import moment from 'moment'
import { usePresentStore } from '@/stores/presentStore'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const presentStore = usePresentStore()
const dayDic = ['日', '月', '火', '水', '木', '金', '土']

const time = computed(() => {
  return moment(presentStore.recentTime?.time)
})

const timeLabel = computed(() => {
  const dayLabel = dayDic[time.value.day()]

  return time.value.format(`YYYY年MM月DD日(${dayLabel}) HH:mm`)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(timeLabel)), 1))
}
}

})